
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m12.6667 4c-4.41781 0-8.00003 3.58222-8.00003 8h-2.66667l3.45778 3.4578.06222.1244 3.59111-3.5822h-2.66667c0-3.44 2.78223-6.22222 6.22226-6.22222 3.44 0 6.2222 2.78222 6.2222 6.22222s-2.7822 6.2222-6.2222 6.2222c-1.7156 0-3.27114-.7022-4.39114-1.8311l-1.26223 1.2622c1.44889 1.4489 3.43997 2.3467 5.65337 2.3467 4.4177 0 8-3.5822 8-8 0-4.41778-3.5823-8-8-8zm-.8889 4.44444v4.44446l3.7778 2.24.6844-1.1378-3.1289-1.8578v-3.68886z","fill":"#4a3428"}})])
          )
        }
      }
    